import { axiosClientV2 } from './axios.client';

/** Access tokens for scripts and AI assistants (server/routes/v2/apiTokens.route.js). */
const failure = (err, fallback) => err?.message || fallback;

export async function listApiTokens() {
  try {
    const data = await axiosClientV2.get('api-tokens');
    return { tokens: data?.tokens || [], error: null };
  } catch (err) {
    return { tokens: [], error: failure(err, 'Failed to load access tokens') };
  }
}

export async function createApiToken({ name, expiresInDays }) {
  try {
    const data = await axiosClientV2.post('api-tokens', { name, expiresInDays });
    return { token: data?.token || '', apiToken: data?.apiToken || null, error: null };
  } catch (err) {
    return { token: '', apiToken: null, error: failure(err, 'Failed to create the token') };
  }
}

export async function revokeApiToken(id) {
  try {
    await axiosClientV2.delete(`api-tokens/${id}`);
    return { error: null };
  } catch (err) {
    return { error: failure(err, 'Failed to revoke the token') };
  }
}

/** The tools an AI assistant sees: one per published flow. */
export async function listMcpTools() {
  try {
    const data = await axiosClientV2.get('mcp/tools');
    return { tools: data?.tools || [], error: null };
  } catch (err) {
    return { tools: [], error: failure(err, 'Failed to load tools') };
  }
}

export function mcpServerUrl() {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}/api/v2/mcp`;
}

/** Config snippets for common MCP clients; `token` may be a placeholder. */
export function mcpClientConfigs(url, token) {
  const auth = `Bearer ${token}`;
  return {
    cursor: JSON.stringify({ mcpServers: { interviewflow: { url, headers: { Authorization: auth } } } }, null, 2),
    claudeCode: `claude mcp add --transport http interviewflow ${url} --header "Authorization: ${auth}"`,
    curl: `curl -s ${url} \\\n  -H "Authorization: ${auth}" \\\n  -H "Content-Type: application/json" \\\n  -H "Accept: application/json, text/event-stream" \\\n  -d '{"jsonrpc":"2.0","id":1,"method":"tools/list"}'`,
  };
}
